import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";

import { MikrotikMapPageComponent } from "./mikrotik-map/mikrotik-map.page";

const routes: Routes = [
	{
		path: "",
		component: MikrotikMapPageComponent,
	},
];

@NgModule({
	imports: [RouterModule.forChild(routes)],
	exports: [RouterModule],
})
export class MikrotikMapPageRoutingModule {}
